<h1>Equipment Master</h1>
<next-object-list
  [object]="'Equipment'"
  [autoHeight]="true"
  (onDoubleClick)="viewDetail($event)"
></next-object-list>
